import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  HostListener,
  Inject,
} from '@angular/core';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';
import { NavigationStart, Router } from '@angular/router';
import { ErrorService } from '@rivethealth/client/api/error-handling/ErrorService';
import { HookDirective } from '@rivethealth/client/common/core/hook';
import {
  useState,
  useSubscription,
} from '@rivethealth/client/common/core/hooks';
import { DirtyService } from '@rivethealth/client/common/dirty/dirty.service';
import { Initializer, INITIALIZER } from '@rivethealth/client/initialize';
import { merge } from 'rxjs';

declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent extends HookDirective {
  private lastURL: string;
  constructor(
    @Inject(ANIMATION_MODULE_TYPE) private readonly animationType: string,
    @Inject(INITIALIZER) private readonly initializers: Initializer[],
    readonly errorService: ErrorService,
    readonly dirtyService: DirtyService,
    readonly router: Router,
    changeDetector: ChangeDetectorRef,
  ) {
    super(changeDetector);
  }

  @HostBinding('class.rv-no-animation')
  get noAnimation() {
    return this.animationType === 'NoopAnimations';
  }

  get _() {
    useSubscription(merge(...this.initializers), {}, []);

    const [isVisible, setIsVisible] = useState(false);

    useSubscription(
      this.errorService.showUpdatePrompt,
      {
        next() {
          setIsVisible(true);
        },
      },
      [],
    );

    useSubscription(
      this.router.events,
      {
        next: event => {
          if (event instanceof NavigationStart) {
            const newURL = event.url.split('?')[0];
            if (newURL != this.lastURL) {
              window.scrollTo(0, 0);
            }
            this.lastURL = newURL;
          }
        },
      },
      [],
    );

    return { isVisible };
  }

  @HostBinding('class.keyboarding') keyboarding = false;

  @HostListener('document:keydown', ['$event.key'])
  keydown(key: string) {
    if (key === 'Tab') {
      this.keyboarding = true;
    }
  }

  @HostListener('document:mousedown')
  mousedown() {
    this.keyboarding = false;
  }
}
